// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upcoming-content>*+*{margin-top:16px}.upcoming-content__heading{margin-block-start:18px;margin-block-end:8px;font-size:16px;font-weight:700;color:#6a7c8f;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;user-select:none}.upcoming-content .no-offer{width:100%;background-color:#10161d}", ""]);
// Exports
module.exports = exports;
